<template>
  <div id="goTop">
    <div class="back-to-top" v-show="visiable" @click="handleScrollTop">
      <i class="fas fa-chevron-circle-up"></i>
    </div>
  </div>
</template>


<script>
export default {
  name: 'goTop',
  data() {
    return {
      scrollTop: null, // 初始化scrollTop
      visiable: false, // 默认不显示
    };
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop;
      if (this.scrollTop > 500) {
        this.visiable = true;
      } else {
        this.visiable = false;
      }
    },

    handleScrollTop() {
      let timer = null;
      const that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (that.scrollTop > 0) {
          that.scrollTop -= 250;
          // eslint-disable-next-line no-multi-assign
          document.body.scrollTop = document.documentElement.scrollTop = that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          that.visiable = false;
        }
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
.back-to-top {
  font-size: 2.5rem;
  color: rgba(221, 221, 221, 0.8);
  position: fixed;
  bottom: 60px;
  right: 20px;
}

i:hover {
  color: #777;
  cursor: pointer;
}
</style>
